<div class="container">
  <div
    class="left"
    [style.background-color]="backgroundColor()">
    <mat-icon
      class="color-{{ iconColor() }}"
      [svgIcon]="svgIcon()">
      {{ icon() }}
    </mat-icon>
  </div>
  <div class="right">
    <p
      class="bold"
      coinEllipsisTooltip
      matTooltip
      [class.truncate]="shouldTruncateText()">
      {{ title() }}
    </p>
    <p
      class="sub-title"
      coinEllipsisTooltip
      matTooltip
      [class.truncate]="shouldTruncateText()">
      {{ subTitle() }}
    </p>
  </div>
</div>
